module.exports = __webpack_public_path__ + "img/tab-icon-location.7c9f46bf.svg";